import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, User, Store, Menu, X, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Shop Friibs", to: "/shop" },
  { label: "Friib Local", to: "/local" },
  { label: "Drops", to: "/shop?sort=newest" },
  { label: "For Brands", to: "/brands" },
];

export default function Header() {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { user } = useAuth();

  const submit = (e) => { e.preventDefault(); nav(`/shop?q=${encodeURIComponent(q)}`); };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/90 border-b border-stone-200/80" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="h-16 flex items-center gap-4">
          <Link to="/" className="shrink-0" data-testid="logo-home"><Logo className="h-12" /></Link>
          <nav className="hidden lg:flex items-center gap-1 ml-2">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="px-3 py-2 rounded-full text-sm font-semibold text-stone-600 hover:text-stone-900 hover:bg-stone-100 transition-colors">
                {n.label}
              </Link>
            ))}
          </nav>

          <form onSubmit={submit} className="hidden md:flex flex-1 max-w-sm ml-auto">
            <div className="relative w-full">
              <Search size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400" />
              <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input"
                placeholder="Search Friibs & brands…"
                className="w-full pl-10 pr-4 py-2.5 rounded-full bg-stone-100 border border-transparent focus:border-stone-300 focus:bg-white outline-none text-sm" />
            </div>
          </form>

          <div className="flex items-center gap-2 ml-auto md:ml-0">
            <Link to="/merchant" data-testid="nav-merchant" className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-semibold text-stone-700 hover:bg-stone-100">
              <Store size={16} /> Merchant
            </Link>
            <Link to={user ? "/account" : "/login"} data-testid="nav-account"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-bold text-white transition-colors"
              style={{ background: "var(--ink)" }}>
              <User size={16} /> {user ? "Account" : "Sign In"}
            </Link>
            <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="menu-toggle">
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-stone-200 bg-white px-4 py-3 space-y-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
              className="block px-3 py-2.5 rounded-lg font-semibold text-stone-700 hover:bg-stone-100">{n.label}</Link>
          ))}
          <Link to="/local" onClick={() => setOpen(false)} className="flex items-center gap-2 px-3 py-2.5 rounded-lg font-semibold" style={{ color: "var(--mint)" }}>
            <MapPin size={16} /> Near Me
          </Link>
        </div>
      )}
    </header>
  );
}
